module.exports = __webpack_public_path__ + "static/media/Gill.7964b142.jpg";